import { floorBandShape, withExteriorOpenGround } from '../inventory/lift-occupancy.js';
import type { RestShape } from '../inventory/floor-move.js';
import { encounterField } from '../../shared/array-types.js';

/** A held encounter with an elided/NULL shape uses the canvas ground plane. */
export function encounterIsShapeless(encounter: Record<string, unknown>): boolean {
  return !!encounter.encounters && !!encounterField(encounter, 'encounter_id')
    && encounterField(encounter, 'encounter_shape') === undefined;
}

/** The bounded exterior volume under no authored room. Its floor is support only at exact foot contact;
 * clearance above it still needs the route's wall reader, including live doors and scene walls. */
export function exteriorGroundAt(shape: RestShape, canvasExterior: boolean, x: number, y: number, z: number,
  tierFt: number): { floor: number; ceiling: number } | null {
  if (shape.boxes.some(box => x >= box.x.min && x <= box.x.max && y >= box.y.min && y <= box.y.max)) return null;
  const band = floorBandShape(shape, x, y, z, canvasExterior);
  if (!band) return null;
  const ground = withExteriorOpenGround(band.shape, x, y, x, y, 40 + tierFt, canvasExterior).boxes.find(box => box.navigationOpenGround
    && x >= box.x.min && x <= box.x.max && y >= box.y.min && y <= box.y.max);
  return ground ? { floor: ground.floor, ceiling: ground.ceiling } : null;
}
